import React, {useEffect} from 'react';
import {Box, Pagination} from '@mui/material';
import {CustomButton} from '../../components';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {getPdfReports} from '../../actions';
import PdfsReportTable from '../../components/CustomTables/PdfReportsTable';
import moment from 'moment';

const EscalatorServicesTab = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    escalatorReports,
    escalatorsReportsPage,
    escalatorsReportsTotalPages,
    pdfLoading,
  } = useSelector(s => s.pdfReports);
  console.log("escalatorReports check: ", escalatorReports)

  const onPageChange = (e, value) => {
    dispatch(getPdfReports({page: value, templateType: 'ESCALATOR'}));
  };

  const getSerialNumber = () => {
        const currentSerial = localStorage.getItem('serialNo') || '001';
        const currentMonth = moment().format('MM');
        const currentYear = moment().format('YY');
        const fullSerial = `${currentSerial}${currentMonth}${currentYear}`;
    
        return fullSerial;
      };

  const addReport = () => {
    navigate('/services/add-escalator-report');
  };

  const onRowClick = obj => {
    const payload = {ordinalNr: getSerialNumber(), ...JSON.parse(obj.payload)};
    navigate(`/escalator_services_pdf`, {state: payload});
  };

  useEffect(() => {
    dispatch(getPdfReports({templateType: 'ESCALATOR'}));
  }, []);

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb="1rem">
        <CustomButton onClick={addReport}>Add escalator report</CustomButton>
      </Box>
      <PdfsReportTable
        list={escalatorReports}
        loading={pdfLoading}
        onRowClick={onRowClick}
      />
      {escalatorsReportsTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={escalatorsReportsTotalPages}
            page={escalatorsReportsPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </Box>
  );
};

export default EscalatorServicesTab;
